export default defineNuxtPlugin((nuxtApp) => {
    const env = useRuntimeConfig();
    const PROJECT_BASE = env.public.PROJECT_BASE;
    
    let globalTimerInterval = null;
    let isTimerActive = false;

    // Funzione per avviare il timer globale
    const startGlobalTimer = () => {
        if (globalTimerInterval || !process.client) return;
        
        const savedTimerState = localStorage.getItem(`timerState${PROJECT_BASE}`);
        if (!savedTimerState) return;
        
        try {
            const timerState = JSON.parse(savedTimerState);
            if (timerState.isPaused) return;
            
            isTimerActive = true;
            console.log('Timer globale avviato');
            
            globalTimerInterval = setInterval(() => {
                try {
                    const currentState = JSON.parse(localStorage.getItem(`timerState${PROJECT_BASE}`) || '{}');
                    if (!currentState.momentoInizio) {
                        stopGlobalTimer();
                        return;
                    }
                    
                    const time = currentState.timerValue ? currentState.timerValue.split(':') : ['0', '0', '0'];
                    let hours = parseInt(time[0]) || 0;
                    let minutes = parseInt(time[1]) || 0;
                    let seconds = parseInt(time[2]) || 0;

                    seconds++;
                    if (seconds >= 60) {
                        seconds = 0;
                        minutes++;
                        if (minutes >= 60) {
                            minutes = 0;
                            hours++;
                        }
                    }

                    const newTimerValue = `${hours < 10 ? '0' + hours : hours}:${
                        minutes < 10 ? '0' + minutes : minutes
                    }:${seconds < 10 ? '0' + seconds : seconds}`;

                    // Aggiorna lo stato in localStorage
                    currentState.timerValue = newTimerValue;
                    currentState.isPaused = false;
                    localStorage.setItem(`timerState${PROJECT_BASE}`, JSON.stringify(currentState));
                    
                    // Aggiorna il titolo della pagina solo se contiene il nome del progetto
                    if (document && document.title) {
                        const titleParts = document.title.split(' | ');
                        if (titleParts.length >= 1) {
                            const baseTitle = titleParts[0];
                            document.title = `${baseTitle} | ${newTimerValue}`;
                        }
                    }
                } catch (error) {
                    console.error('Errore nel timer globale:', error);
                    stopGlobalTimer();
                }
            }, 1000);
        } catch (error) {
            console.error('Errore nell\'avvio del timer globale:', error);
        }
    };

    // Funzione per fermare il timer globale
    const stopGlobalTimer = () => {
        if (globalTimerInterval) {
            clearInterval(globalTimerInterval);
            globalTimerInterval = null;
            isTimerActive = false;
            console.log('Timer globale fermato');
        }
    };

    // Avvia il timer se c'è uno stato salvato
    if (process.client) {
        // Controllo iniziale al caricamento
        setTimeout(() => {
            const savedTimerState = localStorage.getItem(`timerState${PROJECT_BASE}`);
            if (savedTimerState) {
                try {
                    const timerState = JSON.parse(savedTimerState);
                    if (!timerState.isPaused && timerState.momentoInizio) {
                        startGlobalTimer();
                    }
                } catch (error) {
                    console.error('Errore nel parsing dello stato del timer:', error);
                }
            }
        }, 100);

        // Listener per eventi di storage (cambio di tab/finestra)
        window.addEventListener('storage', (event) => {
            if (event.key === `timerState${PROJECT_BASE}`) {
                if (event.newValue) {
                    try {
                        const timerState = JSON.parse(event.newValue);
                        if (!timerState.isPaused && timerState.momentoInizio && !isTimerActive) {
                            startGlobalTimer();
                        } else if (timerState.isPaused && isTimerActive) {
                            stopGlobalTimer();
                        }
                    } catch (error) {
                        console.error('Errore nel parsing dell\'evento storage:', error);
                    }
                } else {
                    // Timer cancellato
                    stopGlobalTimer();
                }
            }
        });

        // Listener per visibilità della pagina
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                const savedTimerState = localStorage.getItem(`timerState${PROJECT_BASE}`);
                if (savedTimerState && !isTimerActive) {
                    try {
                        const timerState = JSON.parse(savedTimerState);
                        if (!timerState.isPaused && timerState.momentoInizio) {
                            startGlobalTimer();
                        }
                    } catch (error) {
                        console.error('Errore nel ripristino del timer:', error);
                    }
                }
            }
        });
    }

    // Esponi le funzioni globalmente
    return {
        provide: {
            timerGlobal: {
                start: startGlobalTimer,
                stop: stopGlobalTimer,
                isActive: () => isTimerActive
            }
        }
    };
});
